import AbstractCarrousel from './AbstractCarrousel'
import css from 'dom-css'
import anime from 'animejs'

export default class Carrousel extends AbstractCarrousel {
  constructor( el ){
    super({
      loop: true,
      drag: true,
      swipe: false
    })

    this._el = el
    
    this.items = this._el.querySelectorAll('.carrousel__item')
    this.total = this.items.length

    this.toLeft = this._el.classList.contains('carrousel--right')
    
    // this.btleft = this._el.querySelector('.carrousel__button--left')
    // this.btright = this._el.querySelector('.carrousel__button--right')

    // this.btleftHandler = ()=>this.previous()
    // this.btrightHandler = ()=>this.next()
    // this.titleClickHandler = ()=>this._clickTitle()

    // this.btleft.addEventListener('click', this.btleftHandler)
    // this.btright.addEventListener('click', this.btrightHandler)
    // for( let i = 0, lg = this.itemsTitle.length; i<lg; i++ ){
    //   this.itemsTitle[i].addEventListener('click', ()=>this._clickTitle(i) )
    // }
    this.items.forEach((item, i)=>{
      item.addEventListener('dragstart', function(e){ 
        e.preventDefault(); 
        e.stopPropagation(); 
        return false; 
      })
      // item.addEventListener('click', (e)=>this._click(e, i))
    })

    this.active = true

    this._resize()
    // App.on('resize', ()=>this._resize())

    this.initTouch()
    this._updatePositions()
    this.start()

    this._el.classList.add('carrousel--active')

    this._el.addEventListener('mouseenter', ()=>{
      this.autoSpeed = 0
    })
    this._el.addEventListener('mouseleave', ()=>{
      this.autoSpeed = 0.001
    })

  }

  kill(){
    if( this.hammer ) this.hammer.destroy()
  }

  _update( to, current = false ){
    
    if( current != false ){
      anime({
        targets: this,
        position: to,
        easing: "easeInOutCubic",
        update: ()=>this._updatePositions(),
        complete: ()=>this._updated()
      })
    }else{
      this.position = to
      this._updatePositions()
    }

  }

  _updatePositions(){

    if( this.active ){

      let x, total1 = this.total - 1
      // console.log(this.position)
      for( let i = 0; i < this.total; i++ ){

        x = ( this.position - i )

        // - Math.floor(this.position / this.total) * this.total
        // if( x < 0 ) x += this.total1 * 
        // if( x > 1 ) x -= Math.floor(x / this.total1) * this.total1
        // x = (i - this.position)

        // x -= Math.floor(x / this.total1) * this.total1

        if( this.toLeft ){
          x *= -107
        }else{
          x *= 107
        }
        

        // if( x > 200 ) x = 150
        // else if( x < -200 ) x = -200

        // if( App.isMobile ){
        //   css( this.items[ i ], {
        //     'transform': 'translate3d(' + (x*0.93) + 'vw,0,0)'
        //   } ) 
        // }else{
          css( this.items[ i ], {
            'transform': 'translate3d(' + -x + '%,0,0)'
          } )
        // }

      }

    }

  }

  _resize(){

    // if( this.items.length > 0 ){
    //   this.itemSize = window.innerWidth / 2 / this.items[ 0 ].getBoundingClientRect().width
    // }
    

    // if( this._el.querySelector('.carrousel__wrapper--height') ){
    //   let maxHeight = 0, box

    //   for (var i = 0; i < this.items.length; i++) {
    //     css( this.items[i], 'height', '' );
    //   }

    //   for (var i = 0; i < this.items.length; i++) {
    //     box = this.items[i].getBoundingClientRect()
    //     if( box.height > maxHeight ) maxHeight = box.height
    //   }

    //   for (var i = 0; i < this.items.length; i++) {
    //     css( this.items[i], 'height', maxHeight );
    //   }
      
    // }

    this._updatePositions()

  }

  // _clickTitle( i ){
  //   this.goto(i)
  // }
}